import { apiGet, apiPut, apiPost } from '../lib/api'
import { dispatchAsync } from './asyncActionMeta'
import { cartToServerPayload, isBulkOrderCartConflictError } from './cartUtils'

export const FETCH_BULK_ORDER_CATALOG = 'FETCH_BULK_ORDER_CATALOG'
export const FETCH_BULK_ORDER_CATALOG_START = 'FETCH_BULK_ORDER_CATALOG_START'
export const FETCH_BULK_ORDER_CATALOG_SUCCESS =
  'FETCH_BULK_ORDER_CATALOG_SUCCESS'
export const FETCH_BULK_ORDER_CATALOG_ERROR = 'FETCH_BULK_ORDER_CATALOG_ERROR'

export const FETCH_BULK_ORDER_LENS_DETAIL = 'FETCH_BULK_ORDER_LENS_DETAIL'
export const FETCH_BULK_ORDER_LENS_DETAIL_START =
  'FETCH_BULK_ORDER_LENS_DETAIL_START'
export const FETCH_BULK_ORDER_LENS_DETAIL_SUCCESS =
  'FETCH_BULK_ORDER_LENS_DETAIL_SUCCESS'
export const FETCH_BULK_ORDER_LENS_DETAIL_ERROR =
  'FETCH_BULK_ORDER_LENS_DETAIL_ERROR'

export const FETCH_BULK_ORDER_CART = 'FETCH_BULK_ORDER_CART'
export const FETCH_BULK_ORDER_CART_START = 'FETCH_BULK_ORDER_CART_START'
export const FETCH_BULK_ORDER_CART_SUCCESS = 'FETCH_BULK_ORDER_CART_SUCCESS'
export const FETCH_BULK_ORDER_CART_ERROR = 'FETCH_BULK_ORDER_CART_ERROR'

export const SAVE_BULK_ORDER_CART = 'SAVE_BULK_ORDER_CART'
export const SAVE_BULK_ORDER_CART_START = 'SAVE_BULK_ORDER_CART_START'
export const SAVE_BULK_ORDER_CART_SUCCESS = 'SAVE_BULK_ORDER_CART_SUCCESS'
export const SAVE_BULK_ORDER_CART_ERROR = 'SAVE_BULK_ORDER_CART_ERROR'

export const SELECT_BULK_ORDER_LENS = 'SELECT_BULK_ORDER_LENS'
export const SET_BULK_ORDER_GRID_CONTEXT = 'SET_BULK_ORDER_GRID_CONTEXT'
export const SET_BULK_ORDER_CATALOG_UI = 'SET_BULK_ORDER_CATALOG_UI'
export const SET_BULK_ORDER_CART_META = 'SET_BULK_ORDER_CART_META'
export const UPSERT_BULK_ORDER_CART_LINE = 'UPSERT_BULK_ORDER_CART_LINE'
export const UPDATE_BULK_ORDER_CART_LINE_QUANTITY =
  'UPDATE_BULK_ORDER_CART_LINE_QUANTITY'
export const REMOVE_BULK_ORDER_CART_LINE = 'REMOVE_BULK_ORDER_CART_LINE'
export const REMOVE_BULK_ORDER_CART_LINES_BY_LENS_ID =
  'REMOVE_BULK_ORDER_CART_LINES_BY_LENS_ID'
export const CLEAR_BULK_ORDER_CART = 'CLEAR_BULK_ORDER_CART'
export const CLEAR_BULK_ORDER_CATALOG_CART_REMAP_NOTICE =
  'CLEAR_BULK_ORDER_CATALOG_CART_REMAP_NOTICE'

export const SUBMIT_BULK_ORDER = 'SUBMIT_BULK_ORDER'
export const SUBMIT_BULK_ORDER_START = 'SUBMIT_BULK_ORDER_START'
export const SUBMIT_BULK_ORDER_SUCCESS = 'SUBMIT_BULK_ORDER_SUCCESS'
export const SUBMIT_BULK_ORDER_ERROR = 'SUBMIT_BULK_ORDER_ERROR'

export const FETCH_BULK_ORDERS = 'FETCH_BULK_ORDERS'
export const FETCH_BULK_ORDERS_START = 'FETCH_BULK_ORDERS_START'
export const FETCH_BULK_ORDERS_SUCCESS = 'FETCH_BULK_ORDERS_SUCCESS'
export const FETCH_BULK_ORDERS_ERROR = 'FETCH_BULK_ORDERS_ERROR'

export const FETCH_BULK_ORDER = 'FETCH_BULK_ORDER'
export const FETCH_BULK_ORDER_START = 'FETCH_BULK_ORDER_START'
export const FETCH_BULK_ORDER_SUCCESS = 'FETCH_BULK_ORDER_SUCCESS'
export const FETCH_BULK_ORDER_ERROR = 'FETCH_BULK_ORDER_ERROR'
export const CLEAR_BULK_ORDER_DETAIL = 'CLEAR_BULK_ORDER_DETAIL'

export const fetchBulkOrderCatalog =
  () =>
  ({ getState, fetch }) => ({
    type: FETCH_BULK_ORDER_CATALOG,
    payload: apiGet({
      fetch,
      endpoint: 'bulk-order/catalog',
      getState,
    }),
  })

export const fetchBulkOrderLensDetail =
  lensId =>
  ({ getState, fetch }) => ({
    type: FETCH_BULK_ORDER_LENS_DETAIL,
    meta: { lensId },
    payload: apiGet({
      fetch,
      endpoint: `bulk-order/catalog/${lensId}/detail`,
      getState,
    }),
  })

export const fetchBulkOrderCart =
  () =>
  ({ getState, fetch }) => ({
    type: FETCH_BULK_ORDER_CART,
    meta: {
      viewerId: getState().app.viewer?._id ?? null,
    },
    payload: apiGet({
      fetch,
      endpoint: 'bulk-order/cart',
      getState,
    }),
  })

export const saveBulkOrderCart =
  () =>
  ({ getState, fetch, dispatch }) => ({
    type: SAVE_BULK_ORDER_CART,
    meta: {
      viewerId: getState().app.viewer?._id ?? null,
    },
    payload: Promise.resolve()
      .then(() =>
        apiPut({
          fetch,
          endpoint: 'bulk-order/cart',
          getState,
          body: cartToServerPayload(getState().bulkOrder.cart),
        }),
      )
      .catch(async error => {
        if (!isBulkOrderCartConflictError(error)) {
          throw error
        }

        // Rebase from server before rethrow; ERROR reducer detects conflict via code.
        try {
          await dispatchAsync(dispatch, fetchBulkOrderCart())
        } catch (_) {
          // Rebase is best-effort; still surface the revision conflict.
        }
        throw error
      }),
  })

export const selectBulkOrderLens = lensId => ({
  type: SELECT_BULK_ORDER_LENS,
  payload: { lensId },
})

export const setBulkOrderGridContext = context => ({
  type: SET_BULK_ORDER_GRID_CONTEXT,
  payload: context,
})

export const setBulkOrderCatalogUi = patch => ({
  type: SET_BULK_ORDER_CATALOG_UI,
  payload: patch,
})

export const setBulkOrderCartMeta = ({ reference, remark }) => ({
  type: SET_BULK_ORDER_CART_META,
  payload: { reference, remark },
})

export const upsertBulkOrderCartLine = line => ({
  type: UPSERT_BULK_ORDER_CART_LINE,
  payload: line,
})

export const updateCartLineQuantity = ({ id, quantity }) => ({
  type: UPDATE_BULK_ORDER_CART_LINE_QUANTITY,
  payload: { id, quantity },
})

export const removeBulkOrderCartLine = ({ id }) => ({
  type: REMOVE_BULK_ORDER_CART_LINE,
  payload: { id },
})

export const removeBulkOrderCartLinesByLensId = ({ lensId }) => ({
  type: REMOVE_BULK_ORDER_CART_LINES_BY_LENS_ID,
  payload: { lensId },
})

export const clearBulkOrderCart = () => ({
  type: CLEAR_BULK_ORDER_CART,
})

export const clearBulkOrderCatalogCartRemapNotice = () => ({
  type: CLEAR_BULK_ORDER_CATALOG_CART_REMAP_NOTICE,
})

export const submitBulkOrder =
  () =>
  ({ getState, fetch }) => {
    const { lines, reference, remark, submissionId } = getState().bulkOrder.cart
    return {
      type: SUBMIT_BULK_ORDER,
      meta: {
        viewerId: getState().app.viewer?._id ?? null,
      },
      payload: apiPost({
        fetch,
        endpoint: 'bulk-order/submit',
        getState,
        body: { lines, reference, remark, submissionId },
      }),
    }
  }

export const fetchBulkOrders =
  query =>
  ({ getState, fetch }) => ({
    type: FETCH_BULK_ORDERS,
    payload: apiGet({
      fetch,
      endpoint: 'bulk-order',
      getState,
      query,
    }),
  })

export const fetchBulkOrder =
  id =>
  ({ getState, fetch }) => ({
    type: FETCH_BULK_ORDER,
    meta: { id },
    payload: apiGet({
      fetch,
      endpoint: `bulk-order/${id}`,
      getState,
    }),
  })

export const clearBulkOrderDetail = () => ({
  type: CLEAR_BULK_ORDER_DETAIL,
})
